import { observable } from 'mobx';

import { SerializedData, Store } from 'bernie-core';
import { FlightsFlexibleSearch, FlightsTripType } from '__generated__/api';

export class FlexibleSearchResultsStore extends Store {
  @observable public loading: boolean;
  @observable public analytics: FlightsFlexibleSearch.Analytics;
  @observable public resultsGrid: FlightsFlexibleSearch.ResultsGrid;
  @observable public title: string;
  @observable public subTitle: string;
  @observable public searchTriggerAction: string;
  @observable public titleAccessibility: string;
  @observable public coverageAnalytics: FlightsFlexibleSearch.CoverageAnalytics;
  @observable public departureLegend: FlightsFlexibleSearch.DepartureLegend;
  @observable public tripType: FlightsTripType;
  @observable public gridTrigger: FlightsFlexibleSearch.GridTrigger;

  public hydrate(data: SerializedData): void {
    Object.assign(this, data);
  }

  public clear(): void {
    this.hydrate(FlexibleSearchResultsStore.DEFAULTS);
  }
}

FlexibleSearchResultsStore.DEFAULTS = {
  analytics: null,
  loading: true,
  resultsGrid: null,
  title: null,
  subTitle: null,
  searchTriggerAction: null,
  titleAccessibility: null,
  coverageAnalytics: null,
  departureLegend: null,
  tripType: null,
  gridTrigger: null
};
